module.exports = __webpack_public_path__ + "static/pr_monochromatic-6a7654ce61cb22cfcdf579879865ecdf.svg";